<div class="comment-widgets">

    <!-- Pagination -->
    <div *ngIf="showPagination" class="comment-row-months">
        <ngb-pagination class="d-flex-center" [collectionSize]="filter.pageTotal" [(page)]="filter.page" [pageSize]="filter.pageSize" [maxSize]="6"
            [rotate]="false" (pageChange)="onPageChange(filter.page)" size="sm">
            <ng-template ngbPaginationPrevious>
            </ng-template> <ng-template ngbPaginationNext>>
            </ng-template>
            <ng-template ngbPaginationNumber let-p>{{ getPageMonth(p) }}</ng-template>
        </ngb-pagination>
    </div>

    <!-- List -->
    <div *ngIf="source?.length && false">
        <div class="d-flex align-items-center comment-row" *ngFor="let givi of source" [ngClass]="{'border-bottom': source.length > 1}">
            <!-- givi.type
                    PurchasePoints = 1, PurchaseProducts = 2, PurchaseGiftcards = 3, PurchaseCoupons = 40, PurchaseCouponPoints = 41, PurchaseEventTickets = 15,

                    ReceivedPoints = 4, ReceivedProducts = 5, ReceivedGiftcards = 6, ReceivedCoupons = 70, ReceivedCouponPoints = 141, ReceivedEventTickets = 25,
                    
                    ExchangeProducts = 7, ExchangeGiftcards = 8, ExchangeCoupons = 9, ExchangeCouponPoints = 241, ExchangeEventTickets = 35 
                -->
            <div class="comment-text w-100">
                <!-- Todas las transacciones que ha hecho el usuario -->
                <ng-container *ngIf="givi.buyerType == 1 && givi.customerId == user?.id">
                    <!-- Purchase Points -->
                    <ng-container *ngIf="givi.type == 1">
                        <div class="font-h6">Compra de puntos (Paquete)</div>
                        <div class="font-c2">{{givi.createdAt | date: 'dd MMMM yyyy' | titlecase}}</div>
                    </ng-container>

                    <!-- Purchase Products with points -->
                    <ng-container *ngIf="givi.type == 2 || givi.type == 7">
                        <div class="font-h6">Gasto de puntos <span class="font-c2 text-muted">(Producto)</span></div>
                        <div class="font-c2">{{givi.createdAt | date: 'dd MMMM yyyy' | titlecase}}</div>
                    </ng-container>
                    <!-- Purchase Giftcard with points -->
                    <ng-container *ngIf="givi.type == 3 || givi.type == 8">
                        <div class="font-h6">Gasto de puntos <span class="font-c2 text-muted">(Givi POP)</span></div>
                        <div class="font-c2">{{givi.createdAt | date: 'dd MMMM yyyy' | titlecase}}</div>
                    </ng-container>
                    <!-- Purchase Products with points -->
                    <ng-container *ngIf="givi.type == 41 || givi.type == 141 || givi.type == 241">
                        <div style="display: flex; align-items: center;">
                            <div class="">
                                <img src="assets/images/gift-category-icon.png" style="width: 20px; height: 20px; margin-right: 10px;">
                            </div>
                            <div class="">
                                <div class="font-h6">Regalé puntos</div>
                                <span class="font-c2 text-muted" *ngIf="givi.customerOwner.id != givi.customer.id">
                                    (Para: {{givi.customerOwner.fullname }})
                                </span> 
                                <div class="font-c2">{{givi.createdAt | date: 'dd MMMM yyyy' | titlecase}}</div>
                                <div *ngIf="givi.customerOwner.id == givi.customer.id && givi.orderStatus == 2">
                                    <br>
                                </div> 
                            </div> 
                        </div>
                    </ng-container>
                </ng-container>

                <!-- Todas las transacciones que ha recibido el usuario -->
                <ng-container *ngIf="givi.customerOwnerId == user?.id">
                    <!-- El mismo usuario que creo el regalo de puntos lo esta acumulando -->
                    <ng-container *ngIf="givi.customerId == givi.customerOwnerId && givi.type == 241">
                        <div style="display: flex; align-items: center;">
                            <div class="">
                                <img src="assets/images/givi-cash-logo.png" style="width: 20px; height: 20px; margin-right: 10px;">
                            </div>
                            <div class="">
                                <div class="font-h6">Acumulación de puntos</div>
                                <div class="font-c2">{{givi.redeemedAt | date: 'dd MMMM yyyy' | titlecase}}</div>
                            </div>
                        </div> 
                    </ng-container>
                    <!-- Otro usuario me regalo puntos -->
                    <ng-container *ngIf="givi.customerId != givi.customerOwnerId && givi.type == 241">
                        <div style="display: flex; align-items: center;">
                            <div class="">
                                <img src="assets/images/gift-category-icon.png" style="width: 20px; height: 20px; margin-right: 10px;">
                            </div>
                            <div class="">
                                <div class="font-h6">Puntos de regalo recibido</div>
                                <span class="font-c2 text-muted" *ngIf="givi.customerOwner.id != givi.customer.id">(De: {{givi.customer.fullname}})</span>
                                <div class="font-c2">{{givi.redeemedAt | date: 'dd MMMM yyyy' | titlecase}}</div>
                            </div>
                        </div> 
                    </ng-container>
                </ng-container>
            </div>

            <!-- Points -->
            <div class="cursor-pointer d-flex-end" (click)="onViewEvent(givi)" style="width: 145px;">
                <div>
                    <!-- Todas las transacciones que ha hecho el usuario -->
                    <ng-container *ngIf="givi.buyerType == 1 && givi.customerId == user?.id">
                        <!-- Purchase Points -->
                        <span *ngIf="givi.type == 1" class="font-h6" style="color: #753CFD;">
                            + {{givi.points}} pts
                        </span>

                        <!-- Purchase Products with points -->
                        <span *ngIf="givi.type == 2 || givi.type == 7" class="font-h6" style="color: #753CFD;">
                            - {{givi.points}} pts
                        </span>
                        <!-- Purchase Giftcard with points -->
                        <span *ngIf="givi.type == 3 || givi.type == 8" class="font-h6" style="color: #753CFD;">
                            - {{givi.points}} pts
                        </span>
                        <!-- Purchase CouponPoints -->
                        <div *ngIf="givi.type == 41 || givi.type == 141 || givi.type == 241" style="text-align: right;">
                            <div class="font-c2">
                                <span style="color: #73CDFF;" *ngIf="givi.customerOwner.id == givi.customer.id && givi.orderStatus == 1">(En tránsito)</span>
                                <span class="text-success" *ngIf="givi.customerOwner.id != givi.customer.id">(Regalo recibido)</span>
                                <span style="color: #FFC300;" *ngIf="givi.customerOwner.id == givi.customer.id && givi.orderStatus == 2 &&
                                onCalculateDateDifference(givi.createdAt, givi.redeemedAt) < 15">(Reintegrado)</span>
                                <span class="text-danger" *ngIf="givi.customerOwner.id == givi.customer.id && givi.orderStatus == 2 &&
                                onCalculateDateDifference(givi.createdAt, givi.redeemedAt) >= 15">(Entrega fallida)</span>
                                <!-- *ngIf="givi.redeemedAt - givi.redeemedAt >= 15" -->
                            </div>
                            <span class="font-h6" style="color: #753CFD; padding-right: 2px;">
                                - {{givi.points}} pts
                            </span>
                        </div>
                    </ng-container>

                    <!-- Otro usuario me regalo puntos -->
                    <ng-container *ngIf="givi.customerOwnerId == user?.id">
                        <!-- Exchange CouponPoints -->
                        <br *ngIf="givi.customerId == givi.customerOwnerId && givi.type == 241">
                        <div style="text-align: right;">
                            <span *ngIf="givi.type == 241 && givi.customerOwner.id == givi.customer.id && givi.orderStatus == 2" 
                                class="font-h6" style="color: #753CFD;">
                                +{{ givi.points}} pts
                            </span>
                        </div>

                        <span *ngIf="givi.type == 241 && !(givi.customerOwner.id == givi.customer.id && givi.orderStatus == 2)" class="font-h6" style="color: #753CFD;">
                            +<span style="padding-left: 1px;"></span>{{ givi.points}} pts
                        </span>
                    </ng-container>
                </div>
                <!-- <i class="fa fa-chevron-right fa-2x m-l-10"></i> -->
            </div>
        </div>
    </div>

    <div *ngIf="!source?.length" class="text-muted font-c2">
        No hay transacciones registradas.
    </div>

    <!-- CARDS LIST -->
    <div *ngIf="source?.length">

        <div class="" *ngFor="let givi of source">

        
            <div class="d-flex-center p-l-20 p-r-20 m-b-20" *ngIf="givi.customerId == givi.customerOwnerId && givi.type == 241 && 
                onCurrentId(givi.id)" (click)="onViewPointsDetails(givi.id)">
                <div class="card-box d-flex" [ngStyle]="givi.buyerType === 2 ? { 'height': '65px', 'padding': '10px' } : null">
                    <div class="col-1 align-self-center p-0">
                        <img class="m-5-5 p-r-10" src="assets/images/pointsIcons/AccumulatePoints.png" width="50">
                    </div>
                    <div class="col-8">
                        <div class="font-c3 font-bold">Acumulación de puntos</div>
                        <div class="font-c3 font-light" *ngIf="givi.buyerType == 1">Puntos reintegrados +{{ givi.points}} pts</div>
                        <div class="font-c3 font-light">{{givi.redeemedAt | date: 'dd MMMM yyyy' | titlecase}}</div>
                        <div class="font-c3 font-medium" *ngIf="givi.customerOwner.id == givi.customer.id && givi.orderStatus == 2 &&
                        onCalculateDateDifference(givi.createdAt, givi.redeemedAt) < 15 && givi.buyerType == 1">Motivo: Reintegrado</div>
                        <div class="font-c3 font-medium" *ngIf="givi.customerOwner.id == givi.customer.id && givi.orderStatus == 2 &&
                        onCalculateDateDifference(givi.createdAt, givi.redeemedAt) >= 15 && givi.buyerType == 1">Motivo: Entrega fallida</div>
                        <!-- Givi bit, marketplace -->
                        <div class="font-c3 font-medium" *ngIf="givi.buyerType == 2"><span class="font-light">Estado:</span> Acumulados</div>
                    </div>
                    <div class="col-3 text-right p-0">
                        <div class="font-c3 font-light" *ngIf="givi.buyerType == 1">-{{givi.points}} pts</div>
                        <div class="font-c3 font-bold" style="color: #753CFD;">+{{givi.points}} pts</div>
                    </div>
                </div>
            </div>

            <div class="" *ngIf="givi.customerOwnerId == user?.id" (click)="onViewPointsDetails(givi.id)">
                <div class="d-flex-center p-l-20 p-r-20 m-b-20" *ngIf="givi.customerId != givi.customerOwnerId && givi.type == 241">
                    <div class="card-box d-flex">
                        <div class="col-1 align-self-center p-0">
                            <img class="m-5-5 p-r-10" src="assets/images/pointsIcons/incomePoints.png" width="50">
                        </div>
                        <div class="col-8">
                            <div class="font-c3 font-bold">Puntos de regalo recibidos</div>
                            <div class="font-c4 font-medium">(<span class="text-muted">De: </span>{{givi.customer.fullname}})</div> 
                            <div class="font-c3 font-light">{{givi.redeemedAt | date: 'dd MMMM yyyy' | titlecase}}</div>
                            <div class="font-c3 font-medium"><span class="font-light">Estado:</span> Acumulados</div>
                        </div>
                        <div class="col-3 text-right p-0">
                            <div class="font-c3 font-bold" style="color: #753CFD;">+{{givi.points}} pts</div>
                        </div>
                    </div>
                </div>
            </div> 

            <div class="d-flex-center p-l-20 p-r-20 m-b-20" *ngIf="(givi.customerId == user?.id && givi.buyerType == 1) 
                && (givi.type == 41 || givi.type == 141 || givi.type == 241)" (click)="onViewPointsDetails(givi.id)"><!--  && onCurrentId(givi.id) -->
                <div class="card-box d-flex" [ngStyle]="givi.orderStatus === 1 ? { 'height': '65px', 'padding': '10px' } : null">
                    <div class="col-1 align-self-center p-0">
                        <img class="m-5-5 p-r-10" src="assets/images/pointsIcons/DiscountPoints.png" width="50">
                    </div>
                    <div class="col-8">
                        <div class="font-c3 font-bold">Regalé puntos</div>
                        <div class="font-c4 font-medium" *ngIf="givi.orderStatus == 2 && givi.customerOwner.fullname">(<span class="text-muted">Recibido por: </span>{{givi.customerOwner.fullname}})</div> 
                        <div class="font-c4 font-medium" *ngIf="givi.orderStatus == 2 && !givi.customerOwner.fullname">(<span class="text-muted">Recibido por: </span>{{givi.customerOwner.email}})</div> 
                        <div class="font-c3 font-light">{{givi.createdAt | date: 'dd MMMM yyyy' | titlecase}}</div>
                        <div class="font-c3 font-medium" *ngIf="givi.orderStatus == 1"><span class="font-light">Estado:</span> En tránsito</div>
                        <div class="font-c3 font-medium" *ngIf="givi.orderStatus == 2"><span class="font-light">Estado:</span> Regalo recibido</div>
                    </div>
                    <div class="col-3 text-right p-0">
                        <div class="font-c3 font-bold" style="color: #753CFD;">-{{givi.points}} pts</div>
                    </div>
                </div>
            </div>

            <div class="d-flex-center p-l-20 p-r-20 m-b-20" *ngIf="(givi.buyerType == 1 && givi.customerId == user?.id) &&
            !(givi.type == 41 || givi.type == 141 || givi.type == 241)" (click)="onViewEvent(givi)">
                <div class="card-box d-flex" style="height: 65px; padding: 10px;">
                    <div class="col-1 align-self-center p-0">
                        <img class="m-5-5 p-r-10" src="assets/images/pointsIcons/SpendPoints.png" width="50">
                    </div>
                    <div class="col-8">
                        
                        <div class="font-c3 font-bold" *ngIf="givi.type == 1">Compra de puntos </div>
                        <div class="font-c4 text-muted" *ngIf="givi.type == 1">(Paquete)</div> 

                        <div class="font-c3 font-bold" *ngIf="givi.type != 1">Gasto de puntos</div>
                        <div class="font-c4 text-muted" *ngIf="givi.type == 2 || givi.type == 7">(Producto)</div> 
                        <div class="font-c4 text-muted" *ngIf="givi.type == 3 || givi.type == 8">(Givi POP)</div> 
                        <div class="font-c4 text-muted" *ngIf="givi.type == 15 || givi.type == 35">(Tickets)</div>

                        <div class="font-c3 font-light">{{givi.createdAt | date: 'dd MMMM yyyy' | titlecase}}</div>
                    </div>
                    <div class="col-3 text-right p-0">
                        <div class="font-c3 font-bold" style="color: #753CFD;" *ngIf="givi.type != 1">-{{givi.points}} pts</div>
                        <div class="font-c3 font-bold" style="color: #753CFD;" *ngIf="givi.type == 1">+{{givi.points}} pts</div>
                    </div>
                </div>
            </div>

        </div>  
    </div>

    <!-- Pagination -->
    <!-- <div *ngIf="showPagination" class="d-flex-end" style="padding: 20px;">
        <ngb-pagination [collectionSize]="filter.pageTotal" [(page)]="filter.page" [pageSize]="filter.pageSize" [maxSize]="4" [rotate]="true" [boundaryLinks]="true"
            (pageChange)="onPageChange(filter.page)">
        </ngb-pagination>
    </div> -->
</div>